import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import {AssistanceService} from '../../../../models/assistanceservice';
import {AssistanceCategory} from '../../../../models/assistance-category';
import {AssistanceProvider} from '../../../../models/assistance-provider';
import * as _ from 'lodash';
@Component({
    selector: 'app-assistance-tickets-comment',
    templateUrl: './assistance-tickets-comment.component.html',
    styleUrls: ['./assistance-tickets-comment.component.css'],
    standalone: false
})
export class AssistanceTicketsCommentComponent implements OnInit {


  @Input() Ticket: EventEmitter<AssistanceTicket>;
  @Input() editFlag: Boolean;
  @Input() disabled: EventEmitter<boolean>;
  editticket: AssistanceTicket;
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  editprovider: AssistanceProvider;
  interval: any;
  @Output() update = new EventEmitter<any>();
  @Output() create = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  isDisabled = false;
  

  ngOnInit() {
    this.reset();
    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }
    this.Ticket.subscribe(data => {
      this.editticket = Object.assign({}, data.Ticket);
      if (this.editticket.service_id) {
          this.editservice = this.editticket.service;
          this.editcategory = this.editticket.service.category;
        }
      if (this.editticket.provider_id && this.editticket.provider_status === 1) {
            this.editprovider = this.editticket.provider;
      }
      if (data.Case) {
        this.timecalcul(this.editticket);
      } else {
        this.editticket.comment = null;
      }
    });
  }

  timecalcul(ticket) {
    this.interval = setInterval(() => {
      const date2 = new Date();
      const date2_ms = date2.getTime() + date2.getTimezoneOffset() * 3600 * 1000 / 60;
      const date1 = new Date(ticket.datetime);
      const date1_ms = date1.getTime();
      // Calculate the difference in milliseconds
      const difference_ms = date2_ms - date1_ms;
      // take out seconds
      const difference_second = difference_ms / 1000;
      if (difference_second > 300)
          this.onCancel();


    }, 1000);
  }

  reset() {
    this.editticket = new AssistanceTicket();
    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.editprovider = new AssistanceProvider();
  }

  onCancel() {
    this.reset();
    clearInterval(this.interval);
    this.cancelEvent.emit();
  }

  onSubmit() {
    this.isDisabled = true;
    if (this.editFlag) {
      const param = {pp1: this.editticket, pp2: true};
      this.update.emit(param);
    } else {
      // this.editticket.ticket_type = 9;
      this.create.emit(this.editticket);
    }
    this.reset();
    clearInterval(this.interval);
  }

}
